var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMoreRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3281 8.25513L15.5 9.427L10.5 14.427L5.5 9.427L6.67188 8.25513L10.5 12.0833L14.3281 8.25513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMoreRegular);
export default __webpack_public_path__ + "static/media/ExpandMoreRegular.c746ac9951b2a3fdb991923324142620.svg";
export { ForwardRef as ReactComponent };